import { ChromeTabCanceler } from "../services/chrome-tab-canceler.service";
import { TabCanceler } from "../services/tab-canceler.service";

export function tabCancel(url: URL) {

  const cancelers: TabCanceler[] = [
    new ChromeTabCanceler(url)
  ];

  return cancelers.some(canceler => canceler.mustBeCanceled());

}
